<template>
	<span>
		<span v-if="isToday">{{ $t('WEBAPP_TODAY') }}</span>
		<span v-else-if="isYesterday">{{ $t('WEBAPP_YESTERDAY') }}</span> <span v-else>{{ $d(_date, 'short') }}</span>
	</span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { isToday as importedIsToday, isYesterday as importedIsYesterday } from '@/helpers/date-helper';

const props = defineProps<{
	date: string;
}>();

const _date = computed(() => new Date(props.date));
const isToday = computed(() => importedIsToday(_date.value));
const isYesterday = computed(() => importedIsYesterday(_date.value));
</script>

<style lang="scss"></style>
